export default "__VITE_ASSET__BPixFdjs__"